module.exports = __webpack_public_path__ + "static/media/Mapleview - 2023.11.10 - Statement of Allegations.46e79e63.pdf";